import { render } from "./HotelPageList.vue?vue&type=template&id=1ec72a11"
import script from "./HotelPageList.vue?vue&type=script&lang=js"
export * from "./HotelPageList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__